export default __webpack_public_path__ + "static/media/gallery_04.2cb86f5a.jpg";